import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'Main',
    component: () => import(/* webpackChunkName: "page-main" */ '@/components/Template/Empty'),
  },
  {
    path: '/signup',
    name: 'Signup',
    component: () => import(/* webpackChunkName: "page-signup" */ '@/components/Modal/Signup'),
  },
  {
    path: '/files',
    name: 'Downloads',
    component: () => import(/* webpackChunkName: "page-files" */ '@/components/Modal/Downloads'),
  },
  {
    path: '/restorePassword',
    name: 'RestorePassword',
    component: () =>
      import(/* webpackChunkName: "page-restore" */ '@/components/Modal/RestorePassword'),
  },
  {
    path: '/restoreUsername',
    name: 'RestoreUsername',
    component: () =>
      import(/* webpackChunkName: "page-restore" */ '@/components/Modal/RestoreUsername'),
  },
  {
    path: '/changePassword',
    name: 'ChangePassword',
    component: () =>
      import(/* webpackChunkName: "page-account" */ '@/components/Modal/ChangePassword'),
  },
  {
    path: '/changeEmail',
    name: 'ChangeEmail',
    component: () =>
      import(/* webpackChunkName: "page-account" */ '@/components/Modal/ChangeEmail'),
  },
  {
    path: '/unbind',
    name: 'Unbind',
    component: () => import(/* webpackChunkName: "page-account" */ '@/components/Modal/Unbind'),
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: () => import(/* webpackChunkName: "page-info" */ '@/components/Modal/Contacts'),
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import(/* webpackChunkName: "page-info" */ '@/components/Modal/Support'),
  },
  {
    path: '/languages',
    name: 'Languages',
    component: () => import(/* webpackChunkName: "page-info" */ '@/components/Modal/LanguageForm'),
  },
  {
    path: '/vote',
    name: 'Vote',
    component: () => import(/* webpackChunkName: "page-vote" */ '@/components/Modal/Vote'),
  },
  {
    path: '/media',
    name: 'Media',
    component: () => import(/* webpackChunkName: "page-media" */ '@/components/Modal/MediaForm'),
  },
  {
    path: '/activate/:md5',
    name: 'Activate',
    component: () => import(/* webpackChunkName: "page-activate" */ '@/components/Modal/Activate'),
    props: route => ({
      md5: route.params.md5,
    }),
  },
  {
    path: '/server/:id?',
    name: 'Server',
    component: () => import(/* webpackChunkName: "page-server" */ '@/components/Modal/ServerForm'),
    props: route => ({
      id: parseInt(route.params.id),
    }),
  },
  {
    path: '/stats/:id?',
    name: 'Statistics',
    component: () => import(/* webpackChunkName: "page-server" */ '@/components/Modal/Statistics'),
    props: route => ({
      id: parseInt(route.params.id),
    }),
  },
  {
    path: '/shop',
    name: 'Shop',
    component: () => import(/* webpackChunkName: "page-shop" */ '@/components/Modal/Shop'),
  },
  {
    path: '/user_agreement',
    name: 'UserAgreement',
    component: () =>
      import(/* webpackChunkName: "page-legal" */ '@/components/Modal/License/UserAgreement'),
  },
  {
    path: '/privacy_agreement',
    name: 'PrivacyAgreement',
    component: () =>
      import(/* webpackChunkName: "page-legal" */ '@/components/Modal/License/PrivacyAgreement'),
  },
  {
    path: '/license_agreement',
    name: 'LicenseAgreement',
    component: () =>
      import(/* webpackChunkName: "page-legal" */ '@/components/Modal/License/LicenseAgreement'),
  },
  {
    path: '/g2a_agreement',
    name: 'G2AAgreement',
    component: () =>
      import(/* webpackChunkName: "page-legal" */ '@/components/Modal/License/G2AAgreement'),
  },
  {
    path: '/rules',
    name: 'Rules',
    component: () =>
      import(/* webpackChunkName: "page-legal" */ '@/components/Modal/License/Rules'),
  },
  {
    path: '/fail',
    name: 'Fail',
    component: () => import(/* webpackChunkName: "page-result" */ '@/components/Modal/Fail'),
  },
  {
    path: '/success',
    name: 'Success',
    component: () => import(/* webpackChunkName: "page-result" */ '@/components/Modal/Success'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "page-auth" */ '@/components/Modal/Login'),
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import(/* webpackChunkName: "page-account" */ '@/components/Modal/Account'),
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import(/* webpackChunkName: "page-auth" */ '@/components/Modal/Logout'),
  },
  {
    path: '/forum',
    name: 'Forum',
    beforeEnter() {
      window.open('https://forum.la2dream.com/', '_blank');
    },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'Main' },
    component: () => import(/* webpackChunkName: "page-404" */ '@/components/Template/NotFound'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
